import { useState } from 'react';

const LOGO_URL =
  'https://static.readdy.ai/image/50d82ed5e67db213de3cd7b55d8920db/7c6a3ed7e0c4b6c2e2894c907f853820.png';

const FOOTER_LINKS = [
  {
    title: '会社情報',
    links: [
      { label: '会社概要', anchor: 'company-info' },
      { label: '選ばれる理由', anchor: 'about' },
      { label: 'お問い合わせ', anchor: 'contact' },
    ],
  },
  {
    title: 'サービス',
    links: [
      { label: 'オフィスIT機器・ネットワーク構築', anchor: 'services' },
      { label: '情報セキュリティ対策', anchor: 'services' },
      { label: 'IT・DX支援', anchor: 'services' },
    ],
  },
  {
    title: 'お問い合わせ',
    links: [
      { label: '無料相談を申し込む', anchor: 'contact' },
      { label: 'お問い合わせフォーム', anchor: 'contact' },
    ],
  },
];

const PRIVACY_POLICY = [
  {
    title: '第1条（個人情報の定義）',
    body: '本プライバシーポリシーにおける「個人情報」とは、個人情報保護法にいう「個人情報」を指し、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日その他の記述等により特定の個人を識別できるもの、または個人識別符号が含まれるものをいいます。',
  },
  {
    title: '第2条（個人情報の取得）',
    body: '当社は、お問い合わせフォームへの入力、メール・電話等によるお問い合わせ、その他のサービス利用に際して、お客様の個人情報を取得します。取得する情報は、氏名・会社名・電話番号・メールアドレス・お問い合わせ内容等です。',
  },
  {
    title: '第3条（個人情報の利用目的）',
    body: '当社は、取得した個人情報を以下の目的で利用します。\n① お問い合わせへの回答・連絡\n② サービスの提供・履行\n③ 新サービスや情報のご案内（メールマガジン等）\n④ サービス改善・統計分析',
  },
  {
    title: '第4条（個人情報の第三者提供）',
    body: '当社は、以下の場合を除き、お客様の個人情報を第三者に提供しません。\n① お客様の同意がある場合\n② 法令に基づく場合\n③ 人の生命・身体・財産の保護に必要な場合\n④ 業務委託先への提供（利用目的の達成に必要な範囲に限ります）',
  },
  {
    title: '第5条（個人情報の安全管理）',
    body: '当社は、個人情報の漏洩・滅失・毀損を防止するため、適切なセキュリティ対策を実施し、個人情報を安全に管理します。個人情報を取り扱う従業者に対しては、適切な教育・監督を行います。',
  },
  {
    title: '第6条（個人情報の開示・訂正・削除）',
    body: 'お客様は、当社が保有するご自身の個人情報について、開示・訂正・利用停止・削除等を請求する権利を有します。ご請求はお問い合わせフォームまたはメールにてご連絡ください。本人確認の上、合理的な期間内に対応いたします。',
  },
  {
    title: '第7条（クッキー等の使用）',
    body: '当社ウェブサイトでは、利便性向上・アクセス解析のためクッキー（Cookie）を使用する場合があります。クッキーによって個人を特定する情報は取得しません。ブラウザの設定によりクッキーを無効にすることができますが、一部のサービスが利用できなくなる場合があります。',
  },
  {
    title: '第8条（プライバシーポリシーの変更）',
    body: '当社は、法令の改正やサービス内容の変更等に応じて、本ポリシーを改定することがあります。変更後のポリシーは当ウェブサイト上に掲載した時点から効力を生じます。',
  },
  {
    title: '第9条（お問い合わせ窓口）',
    body: '個人情報の取り扱いに関するお問い合わせは、下記までご連絡ください。\n\n【個人情報に関する問い合わせ先】\n株式会社湘南ビジネスサポート\n営業所：神奈川県大和市南林間２－１８－４\nお問い合わせフォームよりご連絡ください。',
  },
];

const scrollTo = (anchor: string) => {
  const el = document.getElementById(anchor);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

export default function Footer() {
  const [policyOpen, setPolicyOpen] = useState(false);

  return (
    <>
      <footer className="bg-[#EEF7FC]">
        {/* Top CTA Bar */}
        <div className="bg-[#2B8DB8] px-10 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <p className="text-white/70 text-xs tracking-widest mb-1" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>CONTACT US</p>
            <p className="text-white text-xl font-light tracking-wider" style={{ fontFamily: "'Inter', 'Noto Sans JP', sans-serif" }}>
              オフィスのIT・セキュリティの悩み、まずご相談ください
            </p>
          </div>
          <button
            onClick={() => scrollTo('contact')}
            className="px-8 py-3 border border-white text-white text-xs tracking-widest hover:bg-white hover:text-[#2B8DB8] transition-all duration-300 rounded-full cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            無料相談を申し込む
          </button>
        </div>

        {/* Main Footer */}
        <div className="px-10 py-16">
          <div className="flex flex-col lg:flex-row gap-12">
            {/* Brand Column */}
            <div className="lg:w-64 flex-shrink-0">
              <button onClick={() => scrollTo('hero')} className="flex items-center gap-3 mb-6 cursor-pointer">
                <div className="w-10 h-10 flex items-center justify-center">
                  <img src={LOGO_URL} alt="湘南ビジネスサポート" className="w-10 h-10 object-contain" />
                </div>
                <span className="text-xs text-[#1A2E3A] tracking-wider leading-relaxed" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                  株式会社<br />湘南ビジネスサポート
                </span>
              </button>
              <p className="text-[#5A7A8A] text-xs leading-loose tracking-wider mb-4" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                中小企業のオフィスIT・セキュリティを<br />
                ワンストップでサポートします。<br />
                神奈川県大和市を拠点に、<br />
                地域の企業に寄り添って伴走します。
              </p>
              <div className="text-[#5A7A8A] text-xs leading-loose tracking-wider mb-6" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                <p>【営業所】神奈川県大和市南林間２－１８－４</p>
              </div>
              <div className="flex items-center gap-4">
                {[
                  { icon: 'ri-instagram-line', href: '#' },
                  { icon: 'fa-brands fa-line', href: '#' },
                ].map(({ icon, href }) => (
                  <a key={icon} href={href} rel="nofollow" className="w-8 h-8 flex items-center justify-center border border-[#B8D8EC] rounded-full text-[#5A7A8A] hover:border-[#2B8DB8] hover:text-[#2B8DB8] transition-all duration-300 cursor-pointer">
                    <i className={`${icon} text-sm`} />
                  </a>
                ))}
              </div>
            </div>

            {/* Nav Columns */}
            <div className="flex-1 grid grid-cols-1 md:grid-cols-3 gap-10">
              {FOOTER_LINKS.map((group) => (
                <div key={group.title}>
                  <p className="text-[#1A2E3A] text-xs font-medium tracking-widest mb-5 pb-3 border-b border-[#B8D8EC]" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                    {group.title}
                  </p>
                  <ul className="flex flex-col gap-3">
                    {group.links.map((link) => (
                      <li key={link.label}>
                        <button
                          onClick={() => scrollTo(link.anchor)}
                          className="text-[#5A7A8A] text-xs tracking-wider hover:text-[#2B8DB8] transition-colors duration-300 cursor-pointer text-left"
                          style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                        >
                          {link.label}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#B8D8EC] px-10 py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-[#5A7A8A] text-xs tracking-widest" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            © 2026 株式会社湘南ビジネスサポート All rights reserved.
          </p>
          <button
            onClick={() => setPolicyOpen(true)}
            className="text-[#5A7A8A] text-xs tracking-wider hover:text-[#2B8DB8] transition-colors cursor-pointer"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            プライバシーポリシー
          </button>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      {policyOpen && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center p-6"
          onClick={() => setPolicyOpen(false)}
        >
          <div className="absolute inset-0 bg-[#0A2840]/50 backdrop-blur-sm" />
          <div
            className="relative bg-white rounded-2xl w-full max-w-2xl max-h-[85vh] flex flex-col overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div className="flex items-center justify-between px-8 py-6 border-b border-[#E8F4FB] flex-shrink-0">
              <div>
                <p className="text-[#2B8DB8] text-xs tracking-[0.3em] mb-1" style={{ fontFamily: "'Inter', sans-serif" }}>PRIVACY POLICY</p>
                <h2 className="text-xl font-light text-[#1A2E3A]" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>プライバシーポリシー</h2>
              </div>
              <button
                onClick={() => setPolicyOpen(false)}
                className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-[#EEF7FC] transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-[#5A7A8A] text-xl" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="overflow-y-auto px-8 py-6 flex-1">
              <p className="text-[#5A7A8A] text-xs leading-loose tracking-wider mb-8" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                株式会社湘南ビジネスサポート（以下「当社」）は、お客様の個人情報の保護を重要な責務と考え、以下のとおりプライバシーポリシーを定めます。
              </p>

              <div className="flex flex-col gap-7">
                {PRIVACY_POLICY.map((section) => (
                  <div key={section.title}>
                    <h3 className="text-sm font-medium text-[#1A2E3A] mb-2 tracking-wider" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                      {section.title}
                    </h3>
                    <p className="text-[#5A7A8A] text-xs leading-loose tracking-wider whitespace-pre-line" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                      {section.body}
                    </p>
                  </div>
                ))}
              </div>

              <div className="mt-8 pt-6 border-t border-[#E8F4FB]">
                <p className="text-[#5A7A8A] text-xs tracking-wider" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                  制定日：2026年1月1日<br />
                  株式会社湘南ビジネスサポート
                </p>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="px-8 py-5 border-t border-[#E8F4FB] flex-shrink-0">
              <button
                onClick={() => setPolicyOpen(false)}
                className="w-full py-3 bg-[#2B8DB8] text-white text-xs tracking-widest rounded-lg hover:bg-[#1E6E94] transition-all duration-300 cursor-pointer whitespace-nowrap"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                閉じる
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
